/**
 * Root Reducer
 */
import { combineReducers } from 'redux';

// Import Reducers
import app from './modules/App/AppReducer';
import intl from './modules/Intl/IntlReducer';
import error from './modules/Error/ErrorReducer';
import config from './modules/Config/ConfigReducer';
import cms from './modules/Cms/CmsReducer';
import currency from './modules/Currency/CurrencyReducer';

import users from './modules/User/UserReducer';
import userGroups from './modules/UserGroup/UserGroupReducer';
import institutions from './modules/Institution/InstitutionReducer';
import themes from './modules/Theme/ThemeReducer';
import subjects from './modules/Subject/SubjectReducer';
import sessions from './modules/Session/SessionReducer';
import applicants from './modules/Applicant/ApplicantReducer';
import answers from './modules/Answer/AnswerReducer';
import corrections from './modules/Correction/CorrectionReducer';
import flags from './modules/Flag/FlagReducer';
import video from './modules/Video/VideoReducer';

import invoices from './modules/Invoice/InvoiceReducer';

import conversations from './modules/Conversation/ConversationReducer';
import processes from './modules/Process/ProcessReducer';
import notifications from './modules/Notification/NotificationReducer';

// Combine all reducers into one root reducer
export default combineReducers({
    answers,
    app,
    applicants,
    cms,
    config,
    conversations,
    corrections,
    currency,
    error,
    flags,
    institutions,
    intl,
    invoices,
    notifications,
    processes,
    sessions,
    subjects,
    themes,
    users,
    userGroups,
    video,
});
